import { createTheme } from '@mui/material';

const getTheme = () => {
  const theme = createTheme({
    palette: {
      background: {
        default: '#F5F6FA',
      },
      primary: {
        main: '#1D9AAA',
      },
      secondary: {
        main: '#FFC53F',
      },
      error: {
        main: '#F44336',
      },
      custom: {
        lightGray: '#BCD3D2',
        pageBackground: '#F5F6FA',
        darkBlue: '#32668C',
        lightGreen: '#66BBA9',
        primaryIcon: '#187787',
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
    },
  });

  return createTheme({
    ...theme,
    components: {
      // Button styles
      MuiButton: {
        defaultProps: {
          color: 'inherit',
        },
        styleOverrides: {
          root: {
            '&.MuiButton-colorPrimary': {
              color: theme.palette.text.primary,
            },
          },
          contained: {
            '&.MuiButton-colorPrimary': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&.Mui-disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled,
              },
            },
          },
          outlined: {
            // border: `1px solid ${theme.palette.text.disabled}`,
            '&.Mui-disabled': {
              border: `1px solid ${theme.palette.action.disabledBackground}`,
            },
          },
          text: {
            '&.MuiButton-colorPrimary': {
              color: theme.palette.primary.main,
              '&.Mui-disabled': {
                color: theme.palette.action.disabled,
              },
            },
          },
        },
      },
      // TextField styles
      MuiTextField: {
        defaultProps: {
          variant: 'standard',
          size: 'small',
          autoComplete: 'off',
          inputProps: {
            'data-lpignore': 'true',
            'data-form-type': 'other',
          },
        },
        styleOverrides: {
          root: {
            // label styles
            '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-outlined': {
              whiteSpace: 'normal',
              lineHeight: 'normal',
            },
          },
        },
      },
      // InputBase styles (blocks LastPass on all input variants)
      MuiInputBase: {
        defaultProps: {
          autoComplete: 'off',
          inputProps: {
            'data-lpignore': 'true',
            'data-form-type': 'other',
          },
        },
      },
      // Select styles
      MuiSelect: {
        defaultProps: {
          variant: 'standard',
        },
      },
    },
  });
};

export default getTheme();
